import { isEmpty } from 'lodash'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import * as View from '../../components/common/view.page'
import { AutoCompleteRespTypeEnum } from '../../endpoints/services/graphQueryMgr.service'
import { CSSSelector } from '../../utils/css.selector.helper'
import TileQueryConditionsContainer from './components/conditions'
import * as styles from './search.result.styl'
import {
  autocompleteSessionSearch,
  closeCurrentSession
} from '../../redux/actions/autocomplete.actions'
import AutocompleteTableContainer from './views/autocomplete'
import * as Selectors from './selectors'
import * as CommonSelectors from '../../selectors'
import UsageTableContainer from './views/usage'

interface OwnProps {}

export type Props = OwnProps

type SearchResultComponent<T> = React.FC<T> & {
  CSSSelectors?: {
    breadCrumbs?: CSSSelector
  }
}

const SearchResult: SearchResultComponent<Props> = React.memo(
  (props: Props) => {
    const history = useHistory()
    const dispatch = useDispatch()
    const searchQuery = useSelector(Selectors.getSearchQuery)
    const autoCompleteRespType = useSelector(Selectors.getAutoCompleteRespType)
    const lastUpdate = useSelector(CommonSelectors.getLastUpdate)

    useEffect(() => {
      dispatch(autocompleteSessionSearch())
      return () => {
        dispatch(closeCurrentSession())
      }
    }, [])

    const titleResultPage = !isEmpty(searchQuery)
      ? `Result for: "${searchQuery}"`
      : 'Result search query'

    const showUserActivity =
      autoCompleteRespType ===
      AutoCompleteRespTypeEnum.AUTO_COMPLETE_RESP_TYPE_USAGE
    return (
      <View.ContentPage className={styles.content}>
        <View.HeaderPage lastUpdate={lastUpdate}>
          <View.Breadcrumbs id={SearchResult.CSSSelectors.breadCrumbs.value}>
            <View.BreadcrumbsItem title={titleResultPage} />
          </View.Breadcrumbs>
        </View.HeaderPage>
        <TileQueryConditionsContainer searchQuery={searchQuery} />
        <>
          <div className={styles.userGrid}>
            {!showUserActivity ? (
              <AutocompleteTableContainer history={history} />
            ) : (
              <UsageTableContainer history={history} />
            )}
          </div>
        </>
      </View.ContentPage>
    )
  }
)

SearchResult.CSSSelectors = {
  breadCrumbs: new CSSSelector('searchResultBreadcrumbs')
}

export default SearchResult
